import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
    radiusSelector,
    locationSelector,
    propertyTypeSelector,
    isTravelTimeSearchSelector,
    durationSelector,
    transportTypeSelector
} from '../../reducers/filters';
import {
    StyledIcon,
    MobileQuickSearchBarWrapper,
    Wrapper,
    Divider,
    StyledLocationText,
    StyledRadiusText
} from './MobileQuickSearchButton.styles';
import { Text } from '@blueprint/ui';

import { getTranslator } from '../../shared/i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import { trackQuickSearchButtonClick } from './MobileQuickSearchButton.tracking';
import { ModalTypes } from '../../shared/components/ModalManager/ModalManager.types';
import { useSelectBedsTitle } from 'search/hooks/useSelectBedsTitle';
import { useSelectPriceTitle } from 'search/hooks/useSelectPriceTitle';

export type Props = {
    openModal: (type: ModalTypes) => void;
};

const t = getTranslator(searchTranslations);

export const MobileQuickSearchButton: FC<Props> = ({ openModal }) => {
    const {
        selectedValue: radiusSelectedValue,
        options: radiusOptions
    } = useSelector(radiusSelector);

    const {
        selectedValue: propertySelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const radiusLabel = radiusOptions.find((option) => {
        if (radiusSelectedValue !== '') {
            return option.value === radiusSelectedValue;
        }
        return radiusOptions[0];
    })?.label;

    const propertyTypeLabel = propertyTypeOptions.find(
        (option) => option.value === propertySelectedValue
    )?.label;

    const { selectedValue: locationSelectedValue } = useSelector(
        locationSelector
    );

    const isTravelTimeSearch = useSelector(isTravelTimeSearchSelector);

    const selectBedsTitle = useSelectBedsTitle();
    const selectPriceTitle = useSelectPriceTitle();

    const {
        selectedValue: durationValue,
        options: durationOptions
    } = useSelector(durationSelector);

    const {
        selectedValue: transportTypeSelectedValue,
        options: transportTypeOptions
    } = useSelector(transportTypeSelector);

    const durationTitleDisplay = t(
        `filters.field.duration.options.${durationValue || durationOptions[0]}`
    );

    const travelTypeDurationType = t(
        `filters.field.transportType.options.${
            transportTypeSelectedValue || transportTypeOptions[0]
        }`
    );
    const title = `${durationTitleDisplay} • ${travelTypeDurationType}`;

    return (
        <>
            <Wrapper
                onClick={() => {
                    openModal('search_initiation');
                    trackQuickSearchButtonClick();
                }}
                data-testid="testid_quick_search_modal_button"
            >
                <MobileQuickSearchBarWrapper>
                    <StyledIcon
                        iconId="searchsuggest"
                        strokeColor="icon-dark"
                        color="icon-dark"
                        size="small"
                    />
                    <Text color="text-body">
                        <StyledLocationText color="text-title">
                            {locationSelectedValue}
                        </StyledLocationText>
                        <StyledRadiusText>
                            <Divider />
                            {!isTravelTimeSearch
                                ? `${radiusLabel}`
                                : `${title}`}
                        </StyledRadiusText>
                        <Divider />
                        {selectBedsTitle}
                        <Divider />
                        {selectPriceTitle}
                        <Divider />
                        {propertyTypeLabel}
                    </Text>
                </MobileQuickSearchBarWrapper>
            </Wrapper>
        </>
    );
};
